import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import TooltipCleaner from "./TooltipCleaner";  // Import the TooltipCleaner component
import { useTranslation } from 'react-i18next'; // Import hook
import HomePage from "./HomePage.js";
import Footer from './Footer.js';
import NotFound from './404';
import Forbidden from './403';
import PolitikaZasebnostiPage from './Politika_zasebnosti.js';
import PolitikaPiskotkovPage from './Politika_piskotkov.js';
import PogojiUporabePage from './Pogoji_uporabe.js';
import EURBTCPage from "./EURBTCPage.js";
import MaleCeneRizBeliPage from './Male_cene_riz_beli.js';
import MaleCeneHruhPage from './Male_cene_kruh.js';
import TesteninePage from './Male_cene_testenine.js';
import MesoPage from './Male_cene_meso.js';
import MlekoPage from './Male_cene_mleko.js';
import JajcaPage from './Male_cene_jajca.js';
import MasloPage from './Male_cene_maslo.js';
import JabolkaPage from './Male_cene_jabolka.js';
import BananePage from './Male_cene_banane.js';
import ParadiznikPage from './Male_cene_paradiznik.js';
import CebulaPage from './Male_cene_cebula.js';
import KrompirPage from './Male_cene_krompir.js';
import SladkorPage from './Male_cene_sladkor.js';
import KisPage from './Male_cene_kis.js';
import SolPage from './Male_cene_sol.js';
import KavaPage from './Male_cene_kava.js';
import ZganjePage from './Male_cene_zganje.js';
import MoskaOblekaPage from './Male_cene_moska_obleka.js';
import MoskaSrajcaPage from './Male_cene_moska_srajca.js';
import ZenskaBluzaPage from './Male_cene_zenska_bluza.js';
import OtroskaMajicaPage from './Male_cene_otroska_majica.js';
import ZemeljskiPlinPage from './Male_cene_zemeljski_plin.js';
import KurilnoOljePage from './Male_cene_kurilno_olje.js';
import ElektrikaPage from './Male_cene_elektrika.js';
import PralniStrojPage from './Male_cene_pralni_stroj.js';
import LikalnikPage from './Male_cene_likalnik.js';
import PriborPage from './Male_cene_pribor.js';
import PonevPage from './Male_cene_ponev.js';
import KosilnicaPage from './Male_cene_kosilnica.js';
import PralniPrasekPage from './Male_cene_pralni_prasek.js';
import TekociDetergentPage from './Male_cene_tekoci_detergent.js';
import AspirinPage from './Male_cene_aspirin.js';
import RupurutPage from './Male_cene_rupurut.js';
import SirupKaseljPage from './Male_cene_sirup_kaselj.js';
import VitaminCPage from './Male_cene_vitamin_c.js';
import RenaultClioPage from './Male_cene_renault_clio.js';
import VWPoloPage from './Male_cene_vw_polo.js';
import KoloPage from './Male_cene_kolo.js';
import DieselGorivoPage from './Male_cene_diesel_gorivo.js';
import BencinPage from './Male_cene_bencin.js';
import TehnicniPregledPage from './Male_cene_tehnicni_pregled.js';
import MestniAvtobusPage from './Male_cene_mestni_avtobus.js';
import PrevozTaksiPage from './Male_cene_prevoz_taksi.js';
import PostninaPage from './Male_cene_postnina.js';
import FitnesPage from './Male_cene_fitnes.js';
import KinoPage from './Male_cene_kino.js';
import GledaliscePage from './Male_cene_gledalisce.js';
import CasopisPage from './Male_cene_casopis.js';
import SolskiZvezekPage from './Male_cene_solski_zvezek.js';
import SvincnikPage from './Male_cene_svincnik.js';
import TestenineOmakaPage from './Male_cene_testenine_omaka.js';
import MeniKosiloPage from './Male_cene_meni_kosilo.js';
import PicaPage from './Male_cene_pica.js';
import PalacinkePage from './Male_cene_palacinke.js';
import CocaColaPage from './Male_cene_coca_cola.js';
import EspressoPage from './Male_cene_espresso.js';
import NocitevHotelPage from './Male_cene_nocitev_hotel.js';
import MoskoStrizenjePage from './Male_cene_mosko_strizenje.js';
import ZenskoStrizenjePage from './Male_cene_zensko_strizenje.js';
import OtroskePlenicePage from './Male_cene_otroske_plenice.js';
import PogrebPage from './Male_cene_pogreb.js';
import NepremicnineNovaStanovanjaSlovenijaPage from './Nepremicnine_nova_stanovanja_slovenija.js';
import NepremicnineRabljenaStanovanjaSlovenijaPage from './Nepremicnine_rabljena_stanovanja_slovenija.js';
import NepremicnineRabljenaStanovanjaLjubljanaPage from './Nepremicnine_rabljena_stanovanja_ljubljana.js';
import NepremicnineRabljenaStanovanjaMariborPage from './Nepremicnine_rabljena_stanovanja_maribor.js';
import NepremicnineHisePage from './Nepremicnine_hise.js';
import NetoPlacePage from './Neto_place.js';
import BrutoDomaciProizvodPage from './Bruto_domaci_proizvod.js';
import JavniDolgPage from './Javni_dolg.js';
import ZlatoPage from './Zlato.js';
import SrebroPage from './Srebro.js';
import PragTveganjaRevscinePage from './Prag_tveganja_revscine.js';
import './App.css';

function App() {
  const [latestPrice, setLatestPrice] = useState(null);	
  const { t, i18n } = useTranslation(); // `t` is the translation function, `i18n` provides language management

  // Get the language from localStorage (if available) or default to 'sl'
  const savedLanguage = localStorage.getItem('language') || 'sl';

  // Set the language in i18n based on saved language
  useEffect(() => {
    i18n.changeLanguage(savedLanguage);
  }, [savedLanguage, i18n]);

  const switchLanguage = (lang) => {
    i18n.changeLanguage(lang);  // Change language dynamically
    localStorage.setItem('language', lang);  // Save the selected language in localStorage
  };

  useEffect(() => {
  const fetchLatestBTCPrice = async () => {
    try {
      const response = await fetch("/api/getBTCData");
      const data = await response.json();
      if (data && data.length > 0) {
        const latestEntry = data[data.length - 1];
        setLatestPrice(latestEntry.priceBTCtoEUR);
      }
    } catch (error) {
      console.error("Error fetching BTC data from external source:", error);
    }
  };

  fetchLatestBTCPrice();
}, []);

  return (
    <Router>
      <div>
        <TooltipCleaner />
        <nav className="navbar">
			<div className="navbar-container">
			<div className="navbar-left">
				<a href="/">
					<img
						src={`${process.env.PUBLIC_URL}/Logo1.svg`}
						alt="Logo"
						className="navbar-logo"
					/>
				</a>
			</div>
			<div className="navbar-right">
              {latestPrice && (
                <div className="btc-price" title="Posodobljeno dnevno.">
                  <span>BTCEUR: €{latestPrice.toLocaleString('sl-SI')}</span>
                </div>
              )}
              {/* Flag icons for language switching */}
              <img
                src={`${process.env.PUBLIC_URL}/slovenian-flag.png`}
                alt="Slovenian"
                className="flag-icon"
                onClick={() => switchLanguage('sl')}
              />
              <img
                src={`${process.env.PUBLIC_URL}/english-flag.png`}
                alt="English"
                className="flag-icon"
                onClick={() => switchLanguage('en')}
              />
            </div>
		</div>
        </nav>
        <div className="container">
          <Routes>
            <Route path="/" element={<HomePage />} />
			<Route path="/forbidden" element={<Forbidden />} />
			<Route path="*" element={<NotFound />} />
			<Route path="/politika-zasebnosti" element={<PolitikaZasebnostiPage />} />
			<Route path="/politika-piskotkov" element={<PolitikaPiskotkovPage />} />
			<Route path="/pogoji-uporabe" element={<PogojiUporabePage />} />
            <Route path="/eur-btc" element={<EURBTCPage />} />
            <Route path="/hrana-pijaca/riz-beli" element={<MaleCeneRizBeliPage />} />
            <Route path="/hrana-pijaca/kruh" element={<MaleCeneHruhPage />} />
            <Route path="/hrana-pijaca/testenine" element={<TesteninePage />} />
            <Route path="/hrana-pijaca/meso" element={<MesoPage />} />
            <Route path="/hrana-pijaca/mleko" element={<MlekoPage />} />
            <Route path="/hrana-pijaca/jajca" element={<JajcaPage />} />
            <Route path="/hrana-pijaca/maslo" element={<MasloPage />} />
            <Route path="/hrana-pijaca/jabolka" element={<JabolkaPage />} />
            <Route path="/hrana-pijaca/banane" element={<BananePage />} />
            <Route path="/hrana-pijaca/paradiznik" element={<ParadiznikPage />} />
            <Route path="/hrana-pijaca/cebula" element={<CebulaPage />} />
            <Route path="/hrana-pijaca/krompir" element={<KrompirPage />} />
            <Route path="/hrana-pijaca/sladkor" element={<SladkorPage />} />
            <Route path="/hrana-pijaca/kis" element={<KisPage />} />
            <Route path="/hrana-pijaca/sol" element={<SolPage />} />
            <Route path="/hrana-pijaca/kava" element={<KavaPage />} />
            <Route path="/hrana-pijaca/zganje" element={<ZganjePage />} />
            <Route path="/izdelki/moska-obleka" element={<MoskaOblekaPage />} />
            <Route path="/izdelki/moska-srajca" element={<MoskaSrajcaPage />} />
            <Route path="/izdelki/zenska-bluza" element={<ZenskaBluzaPage />} />
			<Route path="/izdelki/otroska-majica" element={<OtroskaMajicaPage />} />
			<Route path="/izdelki/pralni-stroj" element={<PralniStrojPage />} />
			<Route path="/izdelki/likalnik" element={<LikalnikPage />} />
			<Route path="/izdelki/pribor" element={<PriborPage />} />
			<Route path="/izdelki/ponev" element={<PonevPage />} />
			<Route path="/izdelki/kosilnica" element={<KosilnicaPage />} />
			<Route path="/izdelki/pralni-prasek" element={<PralniPrasekPage />} />
			<Route path="/izdelki/tekoci-detergent" element={<TekociDetergentPage />} />
			<Route path="/izdelki/renault-clio" element={<RenaultClioPage />} />
			<Route path="/izdelki/vw-polo" element={<VWPoloPage />} />
			<Route path="/izdelki/kolo" element={<KoloPage />} />
			<Route path="/izdelki/casopis" element={<CasopisPage />} />
			<Route path="/izdelki/solski-zvezek" element={<SolskiZvezekPage />} />
			<Route path="/izdelki/svincnik" element={<SvincnikPage />} />
			<Route path="/izdelki/otroske-plenice" element={<OtroskePlenicePage />} />
			<Route path="/zdravila/aspirin" element={<AspirinPage />} />
			<Route path="/zdravila/rupurut" element={<RupurutPage />} />
			<Route path="/zdravila/sirup-kaselj" element={<SirupKaseljPage />} />
			<Route path="/zdravila/vitamin-c" element={<VitaminCPage />} />
			<Route path="/energija/diesel-gorivo" element={<DieselGorivoPage />} />
			<Route path="/energija/bencin" element={<BencinPage />} />
			<Route path="/energija/zemeljski-plin" element={<ZemeljskiPlinPage />} />
			<Route path="/energija/kurilno-olje" element={<KurilnoOljePage />} />
			<Route path="/energija/elektrika" element={<ElektrikaPage />} />
			<Route path="/storitev/tehnicni-pregled" element={<TehnicniPregledPage />} />
			<Route path="/storitev/mestni-avtobus" element={<MestniAvtobusPage />} />
			<Route path="/storitev/prevoz-taksi" element={<PrevozTaksiPage />} />
			<Route path="/storitev/postnina" element={<PostninaPage />} />
			<Route path="/storitev/fitnes" element={<FitnesPage />} />
			<Route path="/storitev/kino" element={<KinoPage />} />
			<Route path="/storitev/gledalisce" element={<GledaliscePage />} />
			<Route path="/storitev/nocitev-hotel" element={<NocitevHotelPage />} />
			<Route path="/storitev/mosko-strizenje" element={<MoskoStrizenjePage />} />
			<Route path="/storitev/zensko-strizenje" element={<ZenskoStrizenjePage />} />
			<Route path="/storitev/pogreb" element={<PogrebPage />} />
			<Route path="/restavracija/testenine-omaka" element={<TestenineOmakaPage />} />
			<Route path="/restavracija/meni-kosilo" element={<MeniKosiloPage />} />
			<Route path="/restavracija/pica" element={<PicaPage />} />
			<Route path="/restavracija/palacinke" element={<PalacinkePage />} />
			<Route path="/restavracija/coca-cola" element={<CocaColaPage />} />
			<Route path="/restavracija/espresso" element={<EspressoPage />} />
			<Route path="/nepremicnine/nova-stanovanja-slovenija" element={<NepremicnineNovaStanovanjaSlovenijaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-slovenija" element={<NepremicnineRabljenaStanovanjaSlovenijaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-ljubljana" element={<NepremicnineRabljenaStanovanjaLjubljanaPage />} />
			<Route path="/nepremicnine/rabljena-stanovanja-maribor" element={<NepremicnineRabljenaStanovanjaMariborPage />} />
			<Route path="/nepremicnine/hise" element={<NepremicnineHisePage />} />
			<Route path="/neto-place" element={<NetoPlacePage />} />
			<Route path="/bruto-domaci-proizvod" element={<BrutoDomaciProizvodPage />} />
			<Route path="/javni-dolg" element={<JavniDolgPage />} />
			<Route path="/zlato-btc" element={<ZlatoPage />} />
			<Route path="/srebro-btc" element={<SrebroPage />} />
			<Route path="/prag-tveganja-revscine" element={<PragTveganjaRevscinePage />} />
          </Routes>
        </div>
		<Footer /> {/* Add Footer here */}
      </div>
    </Router>
  );
}

export default App;